import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=2b0b5892&scoped=true&"
import script from "./activity-details.vue?vue&type=script&lang=js&"
export * from "./activity-details.vue?vue&type=script&lang=js&"
import style0 from "./activity-details.vue?vue&type=style&index=0&id=2b0b5892&lang=scss&scoped=true&"
import style1 from "./activity-details.vue?vue&type=style&index=1&id=2b0b5892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b5892",
  null
  
)

export default component.exports